import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import HomeFriendsSection from '../../../organisms/HomeEditorial/HomeFriendsSection';

export default function BandFollowersSection({
  id = 'followers',
  followers = [],
  loaded = false,
  loadFollowersPage,
  onFollowerClick,
  publicMedia = false,
}) {
  const { t } = useTranslation();

  return (
    <HomeFriendsSection
      id={id}
      eyebrow={t('bandPage.followers.eyebrow', { defaultValue: 'Followers' })}
      title={t('bandPage.followers.title', { defaultValue: 'Followers' })}
      side={t('bandPage.followers.side', {
        defaultValue: 'People following this band on Muzone.',
      })}
      showSide={false}
      people={followers}
      onSelectFriend={onFollowerClick}
      showInviteRow={false}
      publicMedia={publicMedia}
      viewAll={loadFollowersPage ? {
        label: t('home.editorial.connections.viewAll', { defaultValue: 'View All' }),
        ariaLabel: t('bandPage.followers.viewAllAria', { defaultValue: 'View all followers' }),
        modalTitle: t('bandPage.followers.modalTitle', { defaultValue: 'Followers' }),
        modalEyebrow: t('bandPage.followers.eyebrow', { defaultValue: 'Followers' }),
        modalAriaLabel: t('bandPage.followers.modalAria', { defaultValue: 'Band followers' }),
        loadPage: loadFollowersPage,
        disabled: !loaded,
        emptyTitle: t('bandPage.followers.emptyTitle', { defaultValue: 'No followers yet' }),
        emptyDescription: t('bandPage.followers.emptyDescription', {
          defaultValue: 'Band followers appear here when available to this viewer.',
        }),
        loadingTitle: t('bandPage.followers.loadingTitle', { defaultValue: 'Loading followers...' }),
        errorTitle: t('bandPage.followers.loadErrorTitle', { defaultValue: 'Unable to load followers' }),
        errorDescription: t('bandPage.followers.loadErrorDescription', {
          defaultValue: 'Followers could not be loaded right now.',
        }),
        retryLabel: t('home.editorial.connections.retry', { defaultValue: 'Try again' }),
        loadMoreLabel: t('home.editorial.connections.loadMore', { defaultValue: 'Load more' }),
        loadingMoreLabel: t('home.editorial.connections.loadingMore', { defaultValue: 'Loading...' }),
      } : null}
      emptyTitle={loaded
        ? t('bandPage.followers.emptyTitle', { defaultValue: 'No followers yet' })
        : t('bandPage.followers.loadingTitle', { defaultValue: 'Loading followers...' })}
      emptyDescription={t('bandPage.followers.emptyDescription', {
        defaultValue: 'Band followers appear here when available to this viewer.',
      })}
      previousLabel={t('bandPage.followers.previousFollowers', {
        defaultValue: 'Scroll followers left',
      })}
      nextLabel={t('bandPage.followers.nextFollowers', {
        defaultValue: 'Scroll followers right',
      })}
      autoScrollDirection="left"
    />
  );
}

BandFollowersSection.propTypes = {
  id: PropTypes.string,
  followers: PropTypes.array,
  loaded: PropTypes.bool,
  loadFollowersPage: PropTypes.func,
  onFollowerClick: PropTypes.func,
  publicMedia: PropTypes.bool,
};
